var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 474,
    viewBox: "0 0 474 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M388.478 307.333C399.629 285.23 404.875 262.633 404.875 236.988C404.875 149.873 334.002 79 246.887 79H237.012V231.287L105.129 307.43L110.067 315.982C124.507 340.994 142.881 359.368 167.893 373.808C192.712 388.139 219.833 394.945 246.622 394.945C298.172 394.945 348.445 369.711 378.513 324.347L378.865 324.55L383.801 316C384.735 314.382 385.633 312.764 386.503 311.144L388.647 307.43L388.478 307.333ZM256.762 99.0984C328.393 104.182 385.125 164.085 385.125 236.988C385.125 259.336 380.841 278.355 371.372 297.424L256.762 231.285V99.0984ZM177.768 356.704C158.494 345.578 144.188 332.34 132.366 314.51L246.887 248.39L361.366 314.485C321.146 373.978 240.901 393.158 177.768 356.704ZM207.387 49.3931H197.512C168.631 49.3931 143.53 56.1194 118.518 70.5607C81.9727 91.6596 55.8302 125.729 44.9077 166.491C33.9851 207.253 39.5904 249.828 60.6917 286.375L65.6292 294.926L207.387 213.083V49.3931ZM187.637 201.679L73.156 267.775C58.569 237.853 55.2853 204.071 63.985 171.602C73.5418 135.936 96.4163 106.126 128.393 87.6635C147.667 76.5361 166.285 70.7644 187.637 69.4408L187.637 201.679Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPie);
export default __webpack_public_path__ + "static/media/chart-pie.09a580384102732fa16ff5a833c9d349.svg";
export { ForwardRef as ReactComponent };